<template>
  <div class="desktop-chart-container">
    <div class="chart-panel" v-show="showInstruments === 'korea' || showInstruments === 'global'">
      <chartBox :symbol="chartSymbol" :symbolList="chartSymbolList" :height="height" />
    </div>
  </div>
</template>

<script>
import ChartBox from '@/components/ChartBox';

export default {
  name: 'ChartPage',
  components: {
    ChartBox,
  },
  computed: {
    getSelectSymbol: function () {
      return window.$store.getters['SocketPrice/getSelectSymbol'];
    },
  },
  watch: {
    getSelectSymbol(newVal) {
      if (newVal == undefined) return;
      this.chartSymbol = newVal;
      this.rStock = Object.assign({}, null);

      //종목이 변경될경우 소켓데이터 연결 갱신
      this.symbol = Object.assign({}, newVal);

      this.nowPrice = { curPr: 0, ydiffPr: 0, open: 0, chGrate: 0, high: 0, low: 0, ydiffSign: 0 };

      this.tikSize = newVal.minmov / newVal.pricescale;

      this.ordStdPrc = 0; //일반주문 가격
    },
  },
  data() {
    return {
      showInstruments: 'global',
      priceReqType: "SCKTP02", //시세 받는방식 socket(SCKTP01), polling(SCKTP02/SCKTP03)
      symbolCdList: [],
      height: 850,
      chartSymbolList: [],
      chartSymbol: null,
      //팝업 창 관련
      cpnAuth: { pcCslPop: false },
    }
  },
  filters: {},
  created() {

    this.selectSymbolList();

  },
  mounted() {

  },

  methods: {
    //창이 닫힐때 호출

    //종목 조회
    async selectSymbolList() {
      await window.$store.dispatch('Symbol/getSecMt'); //월물 조회
      await window.$store.dispatch('Symbol/load'); //종목 조회
      //await window.$store.dispatch('Symbol/coinLoad'); //코인 종목 조회
      this.symbolList = window.$store.getters['Symbol/getSymbolList'];
      // this.coinSymbolList = window.$store.getters['Symbol/getCoinSymbolList'];

      //차트 심볼리스트 디폴트 선물 종목설정
      this.chartSymbolList = window.$store.getters['Symbol/getSymbolList'];

      //저장된 종목이 있으면 비교후 저장된 종목으로 실행
      let favSymbol = null;
      if (this.favoriteSymbol != null) {
        for (let item of this.symbolList) {
          if (this.favoriteSymbol == item.symbolno) {
            favSymbol = item;
          }
        }
      } else {
        favSymbol = this.symbolList[0];
      }

      let korSymbol = null;
      for (let item of this.symbolList) {
        if (item.symbolno == 10) {
          korSymbol = item;
          break;
        }
      }



      //코인 > 선물 이동시 국내선물 저장되어있으면 나스닥으로 변경
      if (this.$route.params.instruments == "global" && favSymbol.symbolno == 10) {
        favSymbol = this.symbolList[0];
      } else if (this.$route.params.instruments == "korea") {
        favSymbol = korSymbol;
      }

      //소켓 시세
      if (this.priceReqType == "SCKTP01") {
        if (this.futUseYn == "Y") {

          if (!window.$store.getters['SocketPrice/getIsConnectPrice']) {
            window.$store.watch(() => window.$store.getters['SocketPrice/getIsConnectPrice'], socketPrice => {
              window.$store.dispatch('SocketPrice/setSubscribeOnPriceList', [])
              if (this.$route.params.instruments == "korea" && korSymbol != null) {
                this.symbolDropdown(korSymbol);
              } else {
                this.symbolDropdown(favSymbol);

                //국내선물
                if (favSymbol.symbolno == 10) {
                  this.showInstruments = 'korea';
                }
              }
            })
          } else {
            window.$store.dispatch('SocketPrice/setSubscribeOnPriceList', [])
            if (this.$route.params.instruments == "korea" && korSymbol != null) {
              this.symbolDropdown(korSymbol);
            } else {
              this.symbolDropdown(favSymbol);

              //국내선물
              if (favSymbol.symbolno == 10) {
                this.showInstruments = 'korea';
              }
            }
          }
        }
        //폴링 시세
      } else if (this.priceReqType == "SCKTP02" || this.priceReqType == "SCKTP03") {
        let symbolList = [];
        if (this.$route.params.instruments == "korea" && korSymbol != null) {
          this.symbolDropdown(korSymbol);
        } else {
          this.symbolDropdown(favSymbol);
        }
      }

      //this.setStockInfo(this.symbolList, null);
    },

    //종목셀렉트 선택
    symbolDropdown(value) {
      window.$store.dispatch('SocketPrice/setSelectSymbol', value);
    },

    setCpnAuth(cpnAuthList) {
      //커스텀 화면 설정
      //console.log("cpnAuthList", cpnAuthList)

      if (cpnAuthList != undefined && cpnAuthList.length > 0) { //커스텀 권한 설정
        let stdordYn = "N";
        cpnAuthList.forEach(item => {
          if (item.authTpCd == "PCSTDORD") { //일반주문 표시여부
            this.stdOrdShow = false;
            stdordYn = "Y";
            if (item.useYn == "N") {
              this.stdOrdShow = false;
            } else {
              this.stdOrdShow = true;
            }
          } else if (item.authTpCd == "PCCSLPOP") { //PC 1:1 문의 자동팝업
            if (item.useYn == "Y") {
              this.cpnAuth.pcCslPop = true;
            }
          } else if (item.authTpCd == "PCNOTICE") { //PC 공지사항 팝업
            if (item.useYn == "Y") {
              this.cpnAuth.pcNotice = true;

              //공지팝업 안뜨기 쿠키 설정 확인
              if (this.$cookies.get("wtsNoticePop") == undefined && this.$cookies.get("wtsNoticePop") == null) {
                //공지사항 팝업 호출
                this.$modal.show('modalNotice');
                //공지사항 더이상 안뜨게 설정
                this.$cookies.set("wtsNoticePop", "N");
              }
            }
          }
        });
        //일반주문 표시여부가 없으면 보이도록 설정
        if (stdordYn == "N") {
          this.stdOrdShow = true;
        }
      } else {
        this.stdOrdShow = true;
      }

    },
  },
}
</script>
